// extracted by mini-css-extract-plugin
export default {"header":"header_header__EH8XF","links":"header_links__owa-r","icons":"header_icons__60kSP","title":"header_title__v7pUy"};